<template>
 <q-page style="">
        <div class="row justify-center" style="margin: auto; height: calc(100vh - 128px);">
            <div class="col-12 col-md-9 q-pa-lg" style="height: 100%;">
                <q-card  style="border-radius: 1rem !important; box-shadow: none !important; height: 100%; background: #fff; position: relative; width: 100%;"> 
                    <q-card-section style=" margin: 0;position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%);  width: 100%;">
                    <div class="row justify-center q-pa-md" style="margin-top: auto; margin-bottom: auto;">
                        <div class="col-xs-12 col-sm-5 col-md-5 col-lg-5 q-py-md q-px-sm text-center">
                            <img  src="@/assets/onboardProcess2.png" style="height: auto; width: 100%; max-height: 450px !important;" >
                        </div>
                        <div class="col-xs-12 col-sm-7 col-md-7 col-lg-7 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-bold q-mb-xs" style="font-size: 24px !important;">Hi There!</div>
                            
                            <div class="text-bold q-mb-sm" style="font-size: 16px !important;">
                                Welcome to Affin Hwang Asset Management.
                             </div>
                                <div>
                                 {{$t("common.onboardMsg")}}
                                
                            </div>
                            <!-- <div >We thank you for your patience and understanding.</div> -->
                            <br>
                            <q-btn unelevated style="background: #ff6666; color: white; border-radius: 0.5rem;"  label="Contact Us" @click="reroute()" ></q-btn>
                        </div>
                    </div>
                    </q-card-section>
                </q-card>
            </div>
        </div>
  </q-page>
    <!-- <q-page >
        <div class="row justify-center ErrorHolder">
            <div class="col-12 col-md-8">
                <q-card  style="height: 40vh; "> 
                    <div class="row justify-center" style="padding-top:10px">
                     
                       
                        <div class="self-end col-xs-4 col-sm-4 col-md-4 q-py-md q-px-sm">
                            <img  src="@/assets/img/onboard.png" style="height:250px;float:right" >
                        </div> 
                        <div class="col-xs-6 col-sm-6 col-md-6 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-h3 bold text-weight-medium" style="color:#0000ffa6;">Hi!</div>
                            </br>
                            <div class="text-h6 bold text-weight-medium" style="color:#0000ffa6;">
                                {{$t("common.onboardMsg")}}
                            </div>
                            </br>
                            <q-btn unelevated rounded color="indigo" style="width:70%" icon="call" label="AHAM Contact Us" @click="reroute()" ></q-btn>
                        </div>
                    </div>
                </q-card>
            </div>
        </div>
    </q-page> -->
</template>
<script>
export default {
      data() {},  
      methods:{
      reroute:function(){
        window.location.href = 'https://affinhwangam.com/speak-to-us/'
      }

  },
 
}
</script>